import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

const PageContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 100%);
`;

const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Breadcrumbs = styled.nav`
  margin-bottom: 30px;
  font-size: 14px;
  color: #666;

  a {
    color: #4f46e5;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  span {
    margin: 0 8px;
    color: #999;
  }
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 40px;
`;

const AppBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #4f46e5;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #1a1a1a;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const LastUpdated = styled.p`
  color: #666;
  font-size: 14px;
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 40px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    padding: 25px;
  }
`;

const TableOfContents = styled.div`
  background: #f8f9ff;
  border-left: 4px solid #4f46e5;
  padding: 20px 25px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 30px;

  h3 {
    color: #1a1a1a;
    margin-bottom: 15px;
    font-size: 1.1rem;
  }

  ol {
    margin: 0;
    padding-left: 20px;
  }

  li {
    margin-bottom: 8px;
  }

  a {
    color: #4f46e5;
    text-decoration: none;
    font-size: 15px;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const Section = styled.section`
  margin-bottom: 35px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const SectionTitle = styled.h2`
  color: #1a1a1a;
  font-size: 1.4rem;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e8eeff;
  display: flex;
  align-items: center;
  gap: 10px;

  .icon {
    color: #4f46e5;
  }
`;

const Paragraph = styled.p`
  color: #444;
  line-height: 1.8;
  margin-bottom: 15px;
  font-size: 15px;
`;

const List = styled.ul`
  color: #444;
  line-height: 1.8;
  margin-bottom: 15px;
  padding-left: 25px;

  li {
    margin-bottom: 10px;
    font-size: 15px;
  }
`;

const DataTable = styled.div`
  overflow-x: auto;
  margin: 20px 0;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    th,
    td {
      padding: 12px 15px;
      text-align: left;
      border-bottom: 1px solid #e8eeff;
    }

    th {
      background: #f0f4ff;
      color: #1a1a1a;
      font-weight: 600;
    }

    td {
      color: #444;
    }

    tr:hover td {
      background: #f8f9ff;
    }
  }
`;

const HighlightBox = styled.div`
  background: #f0f4ff;
  border-left: 4px solid #4f46e5;
  padding: 15px 20px;
  border-radius: 0 8px 8px 0;
  margin: 20px 0;

  p {
    margin: 0;
    color: #444;
    font-size: 14px;
  }

  strong {
    color: #1a1a1a;
  }
`;

const ContactCard = styled.div`
  background: linear-gradient(135deg, #4f46e5 0%, #3730a3 100%);
  color: white;
  padding: 25px;
  border-radius: 12px;
  text-align: center;

  h3 {
    margin-bottom: 15px;
    font-size: 1.2rem;
  }

  p {
    margin-bottom: 10px;
    font-size: 15px;
  }

  a {
    color: white;
    font-weight: 600;
  }
`;

const RelatedLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 30px;
  flex-wrap: wrap;

  a {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #eef2ff;
    color: #4f46e5;
    padding: 12px 20px;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s;

    &:hover {
      background: #4f46e5;
      color: white;
    }
  }
`;

export const ConectaPrivacidadPage = () => {
  return (
    <>
      <Navbar />
      <PageContainer>
        <ContentWrapper>
          <Breadcrumbs>
            <Link to="/">Inicio</Link>
            <span>&rsaquo;</span>
            <span>Politica de Privacidad - Conecta</span>
          </Breadcrumbs>

          <Header>
            <AppBadge>Conecta</AppBadge>
            <Title>Politica de Privacidad</Title>
            <LastUpdated>Ultima actualizacion: 15 de abril de 2026</LastUpdated>
          </Header>

          <Card>
            <TableOfContents>
              <h3>Tabla de Contenidos</h3>
              <ol>
                <li>
                  <a href="#introduccion">Introduccion</a>
                </li>
                <li>
                  <a href="#datos-recopilados">Datos que Recopilamos</a>
                </li>
                <li>
                  <a href="#permisos">Permisos del Dispositivo</a>
                </li>
                <li>
                  <a href="#uso-datos">Como Usamos sus Datos</a>
                </li>
                <li>
                  <a href="#terceros">Terceros y Comparticion de Datos</a>
                </li>
                <li>
                  <a href="#almacenamiento">Almacenamiento y Seguridad</a>
                </li>
                <li>
                  <a href="#derechos">Sus Derechos</a>
                </li>
                <li>
                  <a href="#eliminacion">Eliminacion de Cuenta</a>
                </li>
                <li>
                  <a href="#menores">Privacidad de Menores</a>
                </li>
                <li>
                  <a href="#cambios">Cambios a esta Politica</a>
                </li>
                <li>
                  <a href="#contacto">Contacto</a>
                </li>
              </ol>
            </TableOfContents>

            <Section id="introduccion">
              <SectionTitle>
                <span className="icon">1.</span> Introduccion
              </SectionTitle>
              <Paragraph>
                Bienvenido a Conecta, una aplicacion desarrollada y operada por{" "}
                <strong>Monaco IT Services</strong> (en adelante, "nosotros",
                "nos" o "la Empresa"), con domicilio en Chile. Esta Politica de
                Privacidad describe como recopilamos, usamos, almacenamos y
                protegemos su informacion personal cuando utiliza nuestra
                aplicacion movil Conecta, disponible para iOS y Android.
              </Paragraph>
              <Paragraph>
                Al descargar, instalar o utilizar Conecta, usted acepta las
                practicas descritas en esta Politica de Privacidad. Si no esta
                de acuerdo con estas practicas, le recomendamos no utilizar
                nuestra aplicacion.
              </Paragraph>
              <HighlightBox>
                <p>
                  <strong>Nuestro compromiso:</strong> Nos comprometemos a
                  proteger su privacidad y a ser transparentes sobre como
                  manejamos sus datos. Solo recopilamos la informacion necesaria
                  para proporcionar y mejorar nuestros servicios.
                </p>
              </HighlightBox>
            </Section>

            <Section id="datos-recopilados">
              <SectionTitle>
                <span className="icon">2.</span> Datos que Recopilamos
              </SectionTitle>
              <Paragraph>
                Recopilamos diferentes tipos de informacion para proporcionar y
                mejorar nuestro servicio:
              </Paragraph>
              <DataTable>
                <table>
                  <thead>
                    <tr>
                      <th>Categoria</th>
                      <th>Datos Especificos</th>
                      <th>Proposito</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Datos de Cuenta</strong>
                      </td>
                      <td>Email, nombre, contrasena (encriptada)</td>
                      <td>Autenticacion y gestion de cuenta</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Datos de Organizacion</strong>
                      </td>
                      <td>Codigo de organizacion, equipo asignado</td>
                      <td>Asociar al usuario con su organizacion</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Check-ins</strong>
                      </td>
                      <td>
                        Reflexiones diarias, compromisos, escala emocional
                      </td>
                      <td>Seguimiento del programa de liderazgo</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Conversaciones</strong>
                      </td>
                      <td>Mensajes con el coach de IA</td>
                      <td>Asistencia personalizada de coaching</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Progreso</strong>
                      </td>
                      <td>Semana/dia actual, puntos, resumenes semanales</td>
                      <td>Seguimiento del avance en el programa</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Audio</strong>
                      </td>
                      <td>
                        Grabaciones de voz de reflexiones diarias (check-in y
                        check-out)
                      </td>
                      <td>
                        Permitir al usuario dictar sus respuestas por voz en
                        lugar de escribirlas. Las grabaciones se procesan para
                        transcripcion y se eliminan del dispositivo despues del
                        envio.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Preferencias</strong>
                      </td>
                      <td>
                        Horarios de check-in, zona horaria, token de
                        notificaciones
                      </td>
                      <td>Personalizacion de la experiencia</td>
                    </tr>
                  </tbody>
                </table>
              </DataTable>
            </Section>

            <Section id="permisos">
              <SectionTitle>
                <span className="icon">3.</span> Permisos del Dispositivo
              </SectionTitle>
              <Paragraph>
                Conecta solicita los siguientes permisos en su dispositivo, los
                cuales son necesarios para el funcionamiento de la aplicacion:
              </Paragraph>
              <DataTable>
                <table>
                  <thead>
                    <tr>
                      <th>Permiso</th>
                      <th>Plataforma</th>
                      <th>Proposito</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Microfono (RECORD_AUDIO)</strong>
                      </td>
                      <td>iOS y Android</td>
                      <td>
                        Grabar reflexiones por voz durante los check-ins y
                        check-outs diarios. El audio se procesa para
                        transcripcion y no se almacena permanentemente en
                        nuestros servidores.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Configuracion de audio (MODIFY_AUDIO_SETTINGS)</strong>
                      </td>
                      <td>Android</td>
                      <td>
                        Reproducir sonidos de la aplicacion como el cuenco zen
                        para notificaciones y las guias de respiracion.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Notificaciones</strong>
                      </td>
                      <td>iOS y Android</td>
                      <td>
                        Enviar recordatorios de micropausas y alertas de la
                        Alianza CONECTA antes de situaciones importantes.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </DataTable>
              <HighlightBox>
                <p>
                  <strong>Nota:</strong> Todos los permisos son opcionales y se
                  solicitan en el momento en que la funcionalidad los requiere.
                  Puede revocar cualquier permiso desde la configuracion de su
                  dispositivo en cualquier momento.
                </p>
              </HighlightBox>
            </Section>

            <Section id="uso-datos">
              <SectionTitle>
                <span className="icon">4.</span> Como Usamos sus Datos
              </SectionTitle>
              <List>
                <li>
                  <strong>Proporcionar el servicio:</strong> Facilitar los
                  check-ins diarios, generar retroalimentacion personalizada y
                  mantener su progreso en el programa.
                </li>
                <li>
                  <strong>Coach de IA:</strong> Proporcionar asistencia
                  personalizada de coaching a traves de conversaciones con
                  inteligencia artificial.
                </li>
                <li>
                  <strong>Resumenes y metricas:</strong> Generar resumenes
                  semanales y estadisticas de su progreso.
                </li>
                <li>
                  <strong>Notificaciones:</strong> Enviar recordatorios de
                  check-in y mensajes de su coach.
                </li>
                <li>
                  <strong>Mejoras:</strong> Analizar patrones de uso anonimos
                  para mejorar la aplicacion.
                </li>
              </List>
            </Section>

            <Section id="terceros">
              <SectionTitle>
                <span className="icon">5.</span> Terceros y Comparticion de
                Datos
              </SectionTitle>
              <Paragraph>
                Para proporcionar nuestros servicios, trabajamos con los
                siguientes proveedores:
              </Paragraph>
              <DataTable>
                <table>
                  <thead>
                    <tr>
                      <th>Proveedor</th>
                      <th>Proposito</th>
                      <th>Datos Compartidos</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <strong>OpenAI / Anthropic</strong>
                      </td>
                      <td>Coach de IA y retroalimentacion</td>
                      <td>Contenido de check-ins y conversaciones</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>MongoDB Atlas</strong>
                      </td>
                      <td>Base de datos</td>
                      <td>Todos los datos de la aplicacion</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Expo</strong>
                      </td>
                      <td>Notificaciones push</td>
                      <td>Token de dispositivo</td>
                    </tr>
                  </tbody>
                </table>
              </DataTable>
              <Paragraph>
                No vendemos ni alquilamos su informacion personal a terceros.
                Cada proveedor esta obligado a proteger sus datos y a utilizarlos
                unicamente para los fines especificados.
              </Paragraph>
            </Section>

            <Section id="almacenamiento">
              <SectionTitle>
                <span className="icon">6.</span> Almacenamiento y Seguridad
              </SectionTitle>
              <List>
                <li>
                  <strong>Encriptacion:</strong> Todas las comunicaciones
                  utilizan HTTPS/TLS. Las contrasenas se almacenan con hash
                  bcrypt.
                </li>
                <li>
                  <strong>Tokens seguros:</strong> Los tokens de autenticacion se
                  almacenan en el almacenamiento seguro del dispositivo (Secure
                  Store).
                </li>
                <li>
                  <strong>Acceso limitado:</strong> Solo el personal autorizado
                  tiene acceso a los datos de usuario.
                </li>
                <li>
                  <strong>Retencion:</strong> Mantenemos sus datos mientras su
                  cuenta este activa. Al eliminar su cuenta, todos sus datos se
                  eliminan permanentemente.
                </li>
              </List>
            </Section>

            <Section id="derechos">
              <SectionTitle>
                <span className="icon">7.</span> Sus Derechos
              </SectionTitle>
              <List>
                <li>
                  <strong>Derecho de acceso:</strong> Solicitar una copia de sus
                  datos personales.
                </li>
                <li>
                  <strong>Derecho de rectificacion:</strong> Corregir datos
                  inexactos desde su perfil en la app.
                </li>
                <li>
                  <strong>Derecho de eliminacion:</strong> Eliminar su cuenta y
                  todos sus datos desde la app o contactandonos.
                </li>
                <li>
                  <strong>Derecho de portabilidad:</strong> Solicitar la
                  exportacion de sus datos.
                </li>
              </List>
              <HighlightBox>
                <p>
                  <strong>Usuarios en Chile:</strong> Sus derechos estan
                  protegidos bajo la Ley 19.628 sobre Proteccion de la Vida
                  Privada y sus modificaciones.
                </p>
              </HighlightBox>
            </Section>

            <Section id="eliminacion">
              <SectionTitle>
                <span className="icon">8.</span> Eliminacion de Cuenta
              </SectionTitle>
              <Paragraph>
                Puede eliminar su cuenta y todos sus datos asociados en
                cualquier momento:
              </Paragraph>
              <List>
                <li>
                  <strong>Desde la app:</strong> Vaya a su Perfil y seleccione
                  "Eliminar cuenta" al final de la pagina. Se le pedira
                  confirmacion antes de proceder.
                </li>
                <li>
                  <strong>Por email:</strong> Envie una solicitud a{" "}
                  <a href="mailto:soporte@monaco-it-services.cl">
                    soporte@monaco-it-services.cl
                  </a>{" "}
                  desde el email asociado a su cuenta.
                </li>
              </List>
              <HighlightBox>
                <p>
                  <strong>Importante:</strong> La eliminacion de cuenta es
                  permanente. Se eliminaran todos sus datos incluyendo: check-ins,
                  conversaciones con el coach de IA, progreso del programa,
                  resumenes semanales y cuestionarios. Esta accion no se puede
                  deshacer.
                </p>
              </HighlightBox>
            </Section>

            <Section id="menores">
              <SectionTitle>
                <span className="icon">9.</span> Privacidad de Menores
              </SectionTitle>
              <Paragraph>
                Conecta esta disenada para uso corporativo y profesional. No
                esta dirigida a menores de 18 anos. No recopilamos
                intencionalmente informacion de menores de edad.
              </Paragraph>
            </Section>

            <Section id="cambios">
              <SectionTitle>
                <span className="icon">10.</span> Cambios a esta Politica
              </SectionTitle>
              <Paragraph>
                Podemos actualizar esta Politica de Privacidad ocasionalmente. Le
                notificaremos sobre cambios significativos mediante un aviso
                dentro de la aplicacion y actualizando la fecha de "Ultima
                actualizacion" en esta pagina.
              </Paragraph>
            </Section>

            <Section id="contacto">
              <SectionTitle>
                <span className="icon">11.</span> Contacto
              </SectionTitle>
              <Paragraph>
                Si tiene preguntas sobre esta Politica de Privacidad o sobre como
                manejamos sus datos:
              </Paragraph>
              <ContactCard>
                <h3>Monaco IT Services</h3>
                <p>
                  Email:{" "}
                  <a href="mailto:soporte@monaco-it-services.cl">
                    soporte@monaco-it-services.cl
                  </a>
                </p>
                <p>
                  Sitio web:{" "}
                  <a
                    href="https://monaco-it-services.cl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    monaco-it-services.cl
                  </a>
                </p>
                <p>Pais: Chile</p>
              </ContactCard>
            </Section>

            <RelatedLinks>
              <Link to="/conecta/soporte">Centro de Soporte</Link>
              <Link to="/">Volver al Inicio</Link>
            </RelatedLinks>
          </Card>
        </ContentWrapper>
      </PageContainer>
      <Footer />
    </>
  );
};
